(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197,797],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(813);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3840);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6811);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6531);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var NotFound = function() {
    var theme = (0,_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* .useThemeContext */ .TC)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        theme.setThemeStyle(_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* .ThemeStyles.Light */ .Cz.Light);
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pageNotFound),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().number),
                children: "404"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
                children: "Oops! The page you are looking for doesn\u2019t exist. Try the button below..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/",
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonBack),
                "aria-label": "Back to home",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    children: "Back to home"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFound);


/***/ }),

/***/ 813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_not_found_not_found__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(797);

/* harmony default export */ __webpack_exports__["default"] = (_components_not_found_not_found__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 6531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"not-found_pageNotFound__ODQu6","number":"not-found_number__TljVQ","info":"not-found_info__eH281","buttonBack":"not-found_buttonBack__CZKRo"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);